import { __rest } from 'tslib';
import React from 'react';
import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekTableCell = styled(
// `any` element type: consumers spread MUI-typed prop bags (ref?: Ref<unknown>)
// onto this cell, which a fixed HTMLTableCellElement generic rejects.
React.forwardRef((_a, ref) => {
    var props = __rest(_a, ["disabled"]);
    return React.createElement(TableCell, Object.assign({ ref: ref }, props));
}))(({ theme, disabled }) => (Object.assign({ paddingLeft: 0, fontSize: theme.typography.h5.fontSize, ":first-of-type": {
        paddingLeft: theme.spacing(1),
        borderTopLeftRadius: theme.spacing(0.5),
        borderBottomLeftRadius: theme.spacing(0.5),
    }, border: "none", ":last-of-type": {
        paddingRight: 0,
        borderTopRightRadius: theme.spacing(0.5),
        borderBottomRightRadius: theme.spacing(0.5),
    }, "&.MuiTableCell-head": Object.assign(Object.assign({}, theme.typography.body1), { fontWeight: theme.typography.fontWeightBold, paddingTop: 0, paddingBottom: theme.spacing(1) }), "&.MuiTableCell-body": Object.assign(Object.assign({}, theme.typography.body1), { paddingBottom: theme.spacing(2), paddingTop: theme.spacing(2) }) }, (disabled && {
    color: theme.palette.text.disabled,
}))));

export { PeekTableCell, PeekTableCell as default };
